<div class="ws-step">
  <div class="ws-step-header">
    <span class="ws-step-kicker">Step 1 of your reward</span>
    <h3>Add 3 Sales Reps</h3>
    <p class="text-muted">Give the people who actually make calls a place in this workspace. Their activity is what turns Salesmax into your live team view.</p>
    <div class="ws-trial-reward-progress" role="status" aria-live="polite">
      <div class="ws-trial-reward-progress__topline">
        <div>
          <strong>{{ teamMemberProgress }} of {{ requiredRepresentatives }} reps toward your free admin seat</strong>
          <div class="small">You are the workspace admin, so you do not count as one of the 3 reps.</div>
        </div>
      @if (remainingInvites > 0) {
        <span class="badge badge-light">{{ remainingInvites }} more rep{{ remainingInvites === 1 ? '' : 's' }}</span>
      } @else {
          <span class="badge badge-success"><i class="bi bi-check-circle me-1"></i>Rep target reached</span>
      }
      </div>
      <div class="ws-trial-reward-progress__track" role="progressbar" aria-label="Representatives added" [attr.aria-valuenow]="teamMemberProgress" aria-valuemin="0" [attr.aria-valuemax]="requiredRepresentatives">
        <span [style.width.%]="invitationProgressPercent"></span>
      </div>
    </div>
    <p class="small text-primary mt-2 mb-0">
      <i class="bi bi-phone me-1" aria-hidden="true"></i>
      Next, have all 3 reps install Salesmax on their phones so their real call logs start appearing.
    </p>
  </div>

  <div class="ws-step-body">
    <!-- Add member form -->
    <div class="ws-invite-form mb-4">
      <div class="d-flex align-items-end gap-2">
        <div style="flex: 0 0 160px;">
          <label class="form-label small text-muted">Name</label>
          <input class="form-control" [(ngModel)]="currentName" placeholder="Rep name" />
        </div>
        <div style="flex: 1;">
          <label class="form-label small text-muted">Phone Number</label>
          <ngx-intl-tel-input
            [cssClass]="'form-control'"
            [preferredCountries]="preferredCountries"
            [enableAutoCountrySelect]="true"
            [enablePlaceholder]="true"
            [searchCountryFlag]="true"
            [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
            [selectFirstCountry]="false"
            [selectedCountryISO]="CountryISO.India"
            [maxLength]="15"
            [phoneValidation]="true"
            [numberFormat]="PhoneNumberFormat.National"
            [(ngModel)]="currentPhone"
            name="phone">
          </ngx-intl-tel-input>
        </div>
        <div style="flex: 1;">
          <label class="form-label small text-muted">Email (optional)</label>
          <input class="form-control" type="email" [(ngModel)]="currentEmail" placeholder="email@company.com" />
        </div>
        <button class="btn btn-outline-primary" (click)="addMember()" style="height: 38px;">
          <i class="bi bi-plus-lg"></i> Add
        </button>
      </div>
      <div class="ws-item-meta mt-1">With email, your rep can log in to the web dashboard immediately. Without it, they'll need to sign up first.</div>
    </div>

    <!-- Member list -->
    @if (members.length) {
      <div class="mb-3">
        <h6 class="text-muted mb-2">Team Members ({{ members.length }})</h6>
        @for (member of members; track member.phone?.e164Number) {
          <div class="ws-item-card selected">
            <div class="ws-item-content">
              <div class="ws-item-name">
                {{ member.name || 'Unnamed' }}
                <span class="text-muted ms-2">{{ member.phone?.e164Number }}</span>
              </div>
              <div class="ws-item-meta">
                @if (member.email) {
                  <span><i class="bi bi-envelope me-1"></i>{{ member.email }}</span>
                } @else {
                  <span class="text-warning"><i class="bi bi-exclamation-triangle me-1"></i>No email — will need to sign up separately</span>
                }
              </div>
              <div class="ws-item-meta">
                @switch (member.status) {
                  @case ('pending') { <span class="text-muted">Ready to invite</span> }
                  @case ('inviting') { <span class="text-primary"><span class="spinner-border spinner-border-sm me-1"></span>Inviting...</span> }
                  @case ('invited') { <span class="text-success"><i class="bi bi-check-circle me-1"></i>Invited</span> }
                  @case ('error') { <span class="text-danger"><i class="bi bi-exclamation-circle me-1"></i>{{ member.error }}</span> }
                }
              </div>
            </div>
            @if (member.status === 'pending' || member.status === 'error') {
              <button class="btn btn-sm btn-link text-danger" (click)="removeMember(member)" [attr.aria-label]="'Remove ' + (member.name || 'team member')"><i class="bi bi-x-lg"></i></button>
            }
          </div>
        }
      </div>
    } @else {
      <div class="ws-empty-state">
        <i class="bi bi-people"></i>
        <p>Add 3 sales reps above. Each invite moves you closer to real team visibility and your free admin seat.</p>
      </div>
    }

    <div class="ws-save-row">
      <button mat-raised-button color="primary" (click)="inviteAll()" [disabled]="isInviting || pendingCount === 0">
        @if (isInviting) {
          <span class="spinner-border spinner-border-sm me-1"></span>
        }
        Invite {{ pendingCount }} {{ pendingCount === 1 ? 'Rep' : 'Reps' }}{{ invitedCount + pendingCount >= requiredRepresentatives && !hasFailedInvitations ? ' & Continue' : '' }}
      </button>
    </div>
  </div>
</div>
